<div class="signup">
    <div class="wrap p-grid">
        <div class="p-col-12">
            <span class="logo"></span>
        </div>
        <p-card class="p-col-12 card" *ngIf="!loading">
            <div class="p-grid p-nogutter header">
                <div class="p-col-12">
                    <h2 class="title">{{title}}</h2>
                </div>
                <div class="p-col-12" *ngFor="let description of descriptions">
                    <p>{{ description }}</p>
                </div>
                <ol class="p-col-12 steps" *ngIf="showSteps">
                    <li>Sign up. (done)</li>
                    <li>Create account. (current step)</li>
                    <li>Confirm identity. (next step)</li>
                    <li>Create user.</li>
                    <li>Create environment.</li>
                    <li>Install appliances &amp; agents.</li>
                </ol>
                <div class="p-col-12" *ngIf="showContactSupport">
                    <p>If you have any questions, please contact our support desk at  <a href="tel:1.877.484.8383">+1 877.484.8383</a> (option 2) or email <a href="mailto:support@alertlogic.com">support@alertlogic.com</a></p>
                </div>
            </div>
        </p-card>
        <al-view-helper class="p-col-12" [loading]="loading"></al-view-helper>
    </div>
</div>